import { render } from "./ChartTendencias.vue?vue&type=template&id=b105e7ea"
import script from "./ChartTendencias.vue?vue&type=script&lang=js"
export * from "./ChartTendencias.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__